import React from 'react';

export function keysPuzzle (puzzle, Length) {
    var data = []
        for (var i = 0; i < Length; i++) {
            (data.push(i))

        }

        const newData = JSON.stringify(data)

        

        console.log(newData, '6x6 array')


    return keysPuzzle
    }

   